export default __webpack_public_path__ + "static/media/layout_dark_pattern-thinking.40e1be33.svg";